import { useEffect, useState } from "react";
import ExpBar from "../../../../components/NewDesign/StatusBar/ExpBar";
import {
  EditFilled,
  EyeOnIcon,
  MagicFilled,
  People2Filled,
  PeopleFilled,
  PlayOutline,
  PlusCircularOutlined,
  PlusOutlined,
  ResumeOutline,
  RubbishOutlined,
  SendFilled,
  TickOutlined,
} from "../../../../components/OldDesign/Icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../../components/OldDesign/Loading";
import Button from "../../../../components/NewDesign/Button/Button";
import { useStore } from "../../../../store/useStore";
import Pagination from "../../../../components/OldDesign/Pagination";
import emptyusers_aid from "../../../../assets/emptyusers_aid.png";
import ConfirmationPopup from "../../../../components/NewDesign/Popups/ConfirmationPopup";
import { deleteJobPosition, postJobPosition } from "../../../../api/endpoints";
import { toast } from "react-toastify";
import SearchBar from "components/NewDesign/SearchBar/SearchBar";
import { useTranslation } from "react-i18next";
import { TagWithIcon } from "components/NewDesign/Tags";
import AddProfileButton from "components/NewDesign/Button/AddProfileButton";
import AddPeopleButton from "components/NewDesign/Button/AddPeopleButton";

const JobPositionRow = ({ position, setReload }) => {
  const { t } = useTranslation();
  const [posName, setPosName] = useState(position.name);
  const [seatCount, setSeatCount] = useState(position.seat_count);
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const openAnalysisModal = (id) => {
    navigate(`/jobposition/${id}/home`, {
      state: { previousLocation: location },
    });
  };
  const [editMode, setEditMode] = useState(false);

  const handleEditButton = () => {
    if (!editMode) {
      setEditMode(true);
    } else {
      if (posName === position.name && seatCount === position.seat_count) {
        setEditMode(false);
      } else {
        postJobPosition(
          null,
          { name: posName, seat_count: seatCount },
          `/${position.id}`,
          (res) => {
            setReload((prev) => prev + 1);
            toast.success(t("message.transaction_successful"));
            setEditMode(false);
          },
          (err) => {
            console.log(err);
            toast.error(t("message.transaction_failed"));
            setEditMode(false);
          },
          (bool) => {
            setLoading(bool);
          },
        );
      }
    }
  };

  const handleDeleteButton = () => {
    setShowDeleteModal(true);
  };

  const handlePosNameChange = (e) => {
    const _posName = e.target.value;
    setPosName(_posName);
  };
  return (
    <>
      <div className="flex flex-wrap items-center justify-between rounded-lg border border-neutral-300 bg-neutral-100 px-4 py-2.5 shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] max-lg:gap-3">
        <div className="flex basis-[30%] overflow-ellipsis whitespace-nowrap rounded-md font-medium leading-tight text-primary-800 transition-all max-lg:basis-1/3">
          {editMode ? (
            <input
              title={posName}
              className={`max-w-[240px] overflow-hidden text-ellipsis whitespace-nowrap ${
                editMode && "border border-neutral-300 bg-neutral-200 p-1"
              }`}
              value={posName}
              maxLength={100}
              onChange={handlePosNameChange}
              readOnly={!editMode}
            />
          ) : (
            <p className="mr-2 max-w-[240px] overflow-hidden text-ellipsis whitespace-nowrap font-medium leading-tight text-primary-900">
              {position.name}
            </p>
          )}
          <Button
            onClick={handleEditButton}
            loading={loading}
            className={"border-none bg-neutral-100 p-0"}
            icon={
              <div className="relative">
                <TickOutlined className={`h-4 w-4 text-success-400 ${!editMode && "scale-0"} transition-all`} />
                <EditFilled
                  className={`h-4 w-4 text-primary-900 ${editMode && "scale-0"} absolute left-0 top-0 transition-all`}
                />
              </div>
            }
          />
        </div>
        <div className="flex basis-[15%] items-center max-lg:basis-full">
          <p className="text-[13px] font-medium leading-tight text-primary-900">{position.seat_metacv_count}</p>
          <PeopleFilled className="mb-0.5 h-3 w-3 text-primary-900" />
        </div>
        <div className="flex basis-[25%] flex-col max-lg:basis-full">
          {position.progress_percent_total === 100 ? (
            <Button
              disabled={position.seat_metacv_count < 1}
              onClick={() =>
                navigate(`/analysis/${position.id}`, {
                  state: { previousLocation: location },
                })
              }
              className="flex-1 border-secondary_recruiter-300 bg-secondary_recruiter-300 p-2 text-secondary_recruiter-700"
            >
              <People2Filled className="h-5 w-5" />
              {t("modal.report.compatibility_report")}
            </Button>
          ) : (
            <>
              <span className="text-[13px] font-bold leading-tight text-chart-purple2">
                {position.progress_percent_total} %
              </span>
              <ExpBar className="h-2 bg-secondary_recruiter-700" percent={position.progress_percent_total} />
            </>
          )}
        </div>
        <div className="flex basis-[15%] justify-end gap-1">
          {position.state === "completed" ? (
            <div>
              <Button
                onClick={() => navigate(`/cna/my-positions/${position.id}`)}
                className="flex-1 border-secondary_recruiter-200 bg-secondary_recruiter-200 p-2 text-secondary_recruiter-700"
              >
                <EyeOnIcon className="h-5 w-5" />
              </Button>
            </div>
          ) : (
            <div>
              {position.progress_percent_total > 1 ? (
                <Button
                  onClick={() => openAnalysisModal(position.id)}
                  className="flex-1 border-warning-100 bg-warning-100 p-2 text-warning-300"
                >
                  <ResumeOutline className="h-5 w-5 " />
                </Button>
              ) : (
                <Button
                  onClick={() => openAnalysisModal(position.id)}
                  className="flex-1 border-secondary_applicant-200 bg-secondary_applicant-200 p-2 text-secondary_applicant-700"
                >
                  <PlayOutline className="h-5 w-5" />
                </Button>
              )}
            </div>
          )}
          <Button
            onClick={handleDeleteButton}
            className={"border-neutral-300 bg-neutral-100 p-2"}
            icon={<RubbishOutlined className={"h-5 w-5 text-card_candidate-400"} />}
          />
        </div>
      </div>
      <ConfirmationPopup
        message={t("message.are_you_sure_delete_position", { positionname: position.name })}
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        id={position.id}
        confirmModal={() =>
          deleteJobPosition(
            `/${position.id}`,
            (res) => {
              toast.success(t("message.transaction_successful"));
              setReload((prev) => prev + 1);
            },
            (err) => {
              toast.error(t("message.transaction_failed"));
            },
          )
        }
        confirmationTopic={t("button.delete")}
      />
    </>
  );
};

const MyJobPositions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const getJobPositionList = useStore((state) => state.getJobPositionList);
  const jobPositions = useStore((state) => state.jobPositions);
  const [reload, setReload] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterCompleted, setFilterCompleted] = useState(false);

  // PAGINATION
  const [pageSize, setPageSize] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const options = {
      page: currentPage,
      rows: pageSize,
      keyword: searchKeyword,
      filter: filterCompleted ? { core_cv_completed: 1, tournament_completed: 1 } : {},
    };
    getJobPositionList(options);
  }, [getJobPositionList, currentPage, pageSize, reload, searchKeyword, filterCompleted]);

  if (!jobPositions.isLoaded) {
    return null;
  }
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-wrap items-center justify-between gap-2 pb-4">
        <SearchBar setSearchKeyword={setSearchKeyword} keyword={searchKeyword} />
        <div className="flex items-center gap-2">
          <AddProfileButton />
          <AddPeopleButton />
        </div>
      </div>
      <div className="flex items-center justify-between pb-4">
        <TagWithIcon
          className={`cursor-pointer ${
            filterCompleted ? "bg-secondary_recruiter-600" : "bg-neutral-100 text-primary-800"
          }`}
          onClick={() => setFilterCompleted(!filterCompleted)}
          text={t("filter.completed")}
        />
      </div>
      <div className="mb-4 mr-5 flex items-center justify-between rounded-md bg-[#4d5aa61f] px-4 py-2 max-lg:hidden">
        <div className="basis-[30%]">
          <p className="text-[13px] font-medium leading-tight text-primary-900">{t("table.profile_name")}</p>
        </div>
        <div className="basis-[15%]">
          <p className="text-[13px] font-medium leading-tight text-primary-900">{t("table.number_of_people")}</p>
        </div>
        <div className="basis-[25%]">
          <p className="text-[13px] font-medium leading-tight text-primary-900">{t("table.progress")}</p>
        </div>
        <div className="basis-[15%]">
          <p className="text-center text-[13px] font-medium leading-tight text-primary-900">{t("table.actions")}</p>
        </div>
      </div>
      <div className="-mx-2 -my-1 flex flex-col gap-3 overflow-y-auto px-3 py-1 lg:max-h-[calc(100%-142px)]">
        {!jobPositions.isLoading ? (
          <>
            {jobPositions.data.rows.length ? (
              jobPositions.data.rows.map((position, index) => (
                <JobPositionRow key={index} position={position} setReload={setReload} />
              ))
            ) : (
              <div className="flex flex-1 flex-col items-center justify-center gap-1">
                <img src={emptyusers_aid} alt="empty positions" />
                <p className="text-sm font-semibold text-primary-800">{t("message.ideal_profile_empty")}</p>
                <Button
                  onClick={() => {
                    navigate(`/add-position`, {
                      state: { previousLocation: location, options: { rows: pageSize, page: currentPage } },
                    });
                  }}
                  className={"bg-[radial-gradient(143.14%_158.2%_at_104.39%_0%,#1C8BD8_0%,#132A38_100%)] px-6 py-2"}
                  icon={<PlusCircularOutlined className={"h-4 w-4"} />}
                >
                  {t("button.add")}
                </Button>
              </div>
            )}
          </>
        ) : (
          <Loading />
        )}
      </div>
      <div className="mt-auto pt-2">
        {jobPositions.data.pagination_info.total_row_count > 0 && (
          <Pagination
            dataLength={jobPositions.data.pagination_info.total_row_count}
            setPageSize={setPageSize}
            currentPage={currentPage}
            totalCount={jobPositions.data.pagination_info.total_row_count}
            pageSize={pageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
      </div>
    </div>
  );
};

export default MyJobPositions;
